import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { BrandButton } from "@/components/ui-bits";

export default function Hero() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="home"
      data-testid="section-hero"
      className="relative min-h-screen flex items-center bg-[#F2EDE3] pt-24 pb-16"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 w-full text-center flex flex-col items-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-xs sm:text-sm font-semibold tracking-[0.4em] uppercase text-[#6E6A66]"
        >
          NG Films presenta
        </motion.p>

        <motion.img
          src="/ninagordita-title.png?v=3"
          alt="NIÑAGORDITA"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-8 sm:mt-10 w-full max-w-[340px] sm:max-w-2xl lg:max-w-4xl h-auto select-none"
          draggable={false}
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-6 space-y-1"
        >
          <p className="text-sm sm:text-base text-[#141414]/80">
            Una novela de <span className="font-semibold">Belinda Palacios</span>
          </p>
          <p className="text-[clamp(0.72rem,3.4vw,1.5rem)] font-semibold text-[#141414] whitespace-nowrap">
            Una película protagonizada por Silvana Cañote
          </p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-[#141414]/85"
        >
          ¡Bienvenida a nuestra web! Aquí encontrarás más información sobre la
          novela, la película y el impacto social que impulsamos.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-9"
        >
          <BrandButton
            testid="hero-contribuir-btn"
            onClick={() => go("contribuir")}
          >
            Quiero contribuir con este proyecto
          </BrandButton>
        </motion.div>
      </div>

      <motion.button
        onClick={() => go("la-novela")}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 8, 0] }}
        transition={{ opacity: { delay: 1 }, y: { repeat: Infinity, duration: 1.8 } }}
        className="absolute bottom-7 left-1/2 -translate-x-1/2 text-[#C20A78]"
        aria-label="Bajar"
        data-testid="hero-scroll-down"
      >
        <ChevronDown size={30} />
      </motion.button>
    </section>
  );
}
